import axios from "axios";
import { Metadata } from "@metaplex-foundation/mpl-token-metadata";
import {
    TokenListProvider
} from "@solana/spl-token-registry";
import { TOKEN_PROGRAM_ID } from "@solana/spl-token";
import { useConnection, useWallet } from "@solana/wallet-adapter-react";
import {
    LAMPORTS_PER_SOL,
    PublicKey,
} from "@solana/web3.js";
import React, { useEffect, useState } from "react";

function TokenSelectorMenu(props) {

    const [tokenType, changeMenu] = useState("select");
    const { publicKey } = useWallet();
    const { connection } = useConnection();

    /* get token types */
    const [tokenAccounts, setTokenAccounts] = useState([]);
    const SOL = "SOL";

    useEffect(()=>{
        if(tokenType !== "select"){
        props.setSelectedToken(tokenAccounts[tokenType]);
        }else{
            props.setSelectedToken("");    
        }
    },[tokenType]);

    useEffect(() => {
        if (!publicKey) return;
        async function getTokenAccounts(wallet, connection) {
            if (publicKey) {
                connection.getBalance(publicKey).then((bal) => {
                    const sol = {
                        symbol: SOL,
                        mintAddress: SOL,
                        uri: "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/So11111111111111111111111111111111111111112/logo.png",
                        tokenBalance: bal / LAMPORTS_PER_SOL,
                        decimals: 9,
                    };
                    setTokenAccounts((prevTokenAccounts) => [...prevTokenAccounts, sol]);
                });
            }
            const provider = new TokenListProvider();
            const tokenList = await provider.resolve();

            const filters = [
                {
                    dataSize: 165, //size of account (bytes)
                },
                {
                    memcmp: {
                        offset: 32, //location of our query in the account (bytes)
                        bytes: wallet, //our search criteria, a base58 encoded string
                    },
                },
            ];
            const accounts = await connection.getParsedProgramAccounts(
                TOKEN_PROGRAM_ID, //new PublicKey("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA")
                { filters: filters }
            );
            const parsedAccounts = await Promise.all(
                accounts.map(async (account) => {
                    try {
                        const parsedAccountInfo = account.account.data;
                        const mintAddress = parsedAccountInfo["parsed"]["info"]["mint"];
                        const tokenBalance =
                            parsedAccountInfo["parsed"]["info"]["tokenAmount"]["uiAmount"];
                        const decimals =
                            parsedAccountInfo["parsed"]["info"]["tokenAmount"]["decimals"];
                        let entry = {};

                        const tokenInfo = tokenList
                            .filterByClusterSlug("devnet")
                            .getList()
                            .find((info) => info.address === mintAddress);

                        entry = { ...entry, mintAddress, tokenBalance, decimals };

                        if (tokenInfo) {
                            entry = {
                                ...entry,
                                uri: tokenInfo?.logoURI,
                                symbol: tokenInfo?.symbol,
                            };
                        } else {
                            let mintPubkey = new PublicKey(mintAddress);
                            try {
                                let tokenmetaPubkey = await Metadata.getPDA(mintPubkey);
                                const tokenmeta = await Metadata.load(
                                    connection,
                                    tokenmetaPubkey
                                );
                                const uri = await axios.get(tokenmeta.data?.data?.uri);
                                entry = {
                                    ...entry,
                                    symbol: tokenmeta.data?.data?.symbol,
                                    uri: uri.data.image,
                                };
                            } catch (error) {
                                entry = { ...entry, uri: "", symbol: mintAddress };
                            }
                        }

                        return entry;
                    } catch (error) {
                        console.error(error);
                    }
                })
            );
            const filteredAccounts = parsedAccounts.filter((account) => account);
            setTokenAccounts((prevTokenAccounts) => [
                ...prevTokenAccounts,
                ...filteredAccounts,
            ]);
        }

        getTokenAccounts(publicKey.toString(), connection);

        return () => {
            setTokenAccounts([]);
        };
    }, [publicKey, connection])

    return (
        <>
            <select
                disabled={!publicKey}
                value={tokenType}
                onChange={event => changeMenu(event.target.value)}
                name="tokenMenu"
                style={{padding:"20px",width:"50%",margin:"10px 0",marginBottom:"5vh",display:"block", fontSize:"1.2em"}}
                >
                <option value="select">Select token</option>
                {tokenAccounts.map((account, i, arr) => (
                    <option value={i}>{account.symbol}(Balance:{account.tokenBalance})</option>
                ))}

            </select>
        </>
    );
};

export default TokenSelectorMenu;